module.exports = __webpack_public_path__ + "img/staff-default-man.22afe017.png";